export const bonuses = [
  {
    number: 1,
    title: 'Perio Case Decoder™ — 20 Educational Practice Cases',
    value: '$47',
    image: 'https://cdn.magicpatterns.com/uploads/hrvutA7PGkm5PEFiAu47iV/BONUS_1_PERIO-EN.png',
    intro:
      'I wanted to give you a way to put the framework into practice rather than simply read about it. Perio Case Decoder™ contains a collection of fictional educational scenarios designed to help you organize periodontal information and structure your questions.',
    listLabel: 'Each case includes',
    list: [
      'A case summary.',
      'Relevant fictional background information.',
      'Educational findings and observations.',
      'Questions for analysis.',
      'Prompts for identifying missing information.',
      'Discussion questions.',
      'An educational answer guide.',
      'References for further study.',
    ],
    note: 'The cases are designed for learning and discussion, not for automatically diagnosing patients or prescribing treatment.',
  },
  {
    number: 2,
    title: 'The 15-Minute Perio Case Review Protocol™',
    value: '$37',
    image: 'https://cdn.magicpatterns.com/uploads/gSKhxDS5mZ5YQzzniwm47w/BONUS_2_PERIO-EN.png',
    intro:
      'This is the condensed version of the Perio Blueprint™ framework. I created it for those moments when you want to organize the information available without opening the entire collection.',
    listLabel: 'Inside, you’ll find',
    list: [
      'A one-page case overview.',
      'A periodontal information checklist.',
      'A findings-organization section.',
      'A classification-review section.',
      'An information-gap record.',
      'A risk and complexity review worksheet.',
      'A documentation summary.',
    ],
    note: 'The 15-minute target refers to completing the organizational worksheet when the necessary information is available. It does not guarantee that a complete clinical evaluation, diagnosis, or treatment plan can be performed in that time.',
  },
  {
    number: 3,
    title: 'The Perio Error & Knowledge Gap Library™',
    value: '$39',
    image: 'https://cdn.magicpatterns.com/uploads/kr7bwQZsBQy1tCLyvgk66m/BONUS_3_PERIO-EN.png',
    intro:
      'Sometimes, the most useful thing you can do while studying is recognize which concepts you haven’t fully connected yet. I designed this resource to help you identify common organizational and learning gaps that deserve further review.',
    listLabel: 'Topics include',
    list: [
      'Confusing individual findings with an overall diagnostic conclusion.',
      'Overlooking missing information.',
      'Misunderstanding classification terminology.',
      'Failing to distinguish observations from interpretations.',
      'Drawing conclusions from incomplete records.',
      'Overlooking the context in which findings were obtained.',
      'Failing to document uncertainty.',
      'Confusing general educational principles with patient-specific decisions.',
      'Neglecting to revisit unresolved questions.',
    ],
    note: 'The purpose is to support learning and critical thinking, not to suggest that every clinical complication results from a single reasoning error.',
  },
  {
    number: 4,
    title: '30 ChatGPT Prompts for Periodontal Study™',
    value: '$29',
    image: 'https://cdn.magicpatterns.com/uploads/16a37Uz1ooisbhDu3n7Vgb/BONUS_4_PERIO-EN.png',
    intro:
      'I also wanted to help you use AI more effectively as an educational assistant. This collection of prompts helps you organize study materials and create exercises that support your learning.',
    listLabel: 'Use the prompts to',
    list: [
      'Generate periodontal review questions.',
      'Create fictional educational scenarios.',
      'Test your understanding of classification concepts.',
      'Prepare case-discussion questions.',
      'Organize notes from scientific articles.',
      'Create study flashcards.',
      'Build revision exercises.',
      'Compare concepts from verified sources.',
      'Identify topics that need further verification.',
    ],
    note: 'These prompts are intended for education and study, not for delegating patient-specific diagnosis or treatment decisions to AI.',
  },
  {
    number: 5,
    title: 'The 30-Point Perio Study & Case Review Checklist™',
    value: '$19',
    image: 'https://cdn.magicpatterns.com/uploads/3P1CAQZ19HjaW4gp8A4Tdv/BONUS_5_PERIO-EN.png',
    intro:
      'I created this checklist to give you a simple way to review your work before completing a study session or preparing an educational case discussion.',
    listLabel: 'Use it when',
    list: [
      'Preparing a periodontal case discussion.',
      'Reviewing available examination information.',
      'Studying classification concepts.',
      'Organizing case documentation.',
      'Preparing an academic presentation.',
      'Reviewing follow-up information.',
      'Identifying unresolved questions.',
      'Checking whether your references have been verified.',
    ],
    note: 'The checklist supports systematic review without replacing professional judgment or the requirements of your clinical setting.',
  },
];
